import * as React from "react"

function TitleLearn(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={211} height={109} viewBox="0 0 211 109" {...props}>
      <title>{"What will I learn?"}</title>
      <g fill="none" fillRule="evenodd">
        <text
          fontFamily="Licenz"
          fontSize={34}
          letterSpacing={0.117}
          fill="#FFF"
          transform="translate(8)"
        >
          <tspan x={15.815} y={26}>
            {"WHAT WILL I"}
          </tspan>
        </text>
        <text
          fontFamily="HyperwaveTwo, Hyperwave Two"
          fontSize={89}
          fill="#E3E833"
          transform="translate(8)"
        >
          <tspan x={2} y={90}>
            {"learn?"}
          </tspan>
        </text>
      </g>
    </svg>
  )
}

export default TitleLearn
